const OpenSourceComponent = () => (
    <section id="github" className="py-32 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/30 to-black"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
                <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                    Open Source
                </h2>
                <p className="mt-4 text-xl text-gray-400">Dołącz do społeczności deweloperów</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                    <h3 className="text-4xl font-bold mb-6 text-white">CageEEG na GitHub</h3>
                    <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                        Projekt CageEEG udostępnia interfejsy dostępu do danych bez ograniczeń. Możesz przeglądać kod, zgłaszać problemy, proponować
                        ulepszenia i tworzyć własne rozszerzenia.
                    </p>

                    <div className="space-y-4 mb-8">
                        <div className="flex items-center gap-4">
                            <svg className="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                            <span className="text-white font-semibold">Wkrótce</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"
                                 viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path>
                            </svg>
                            <span className="text-white font-semibold">Wkrótce</span>
                        </div>
                        <div className="flex items-center gap-4">
                            <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"
                                 viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
                            </svg>
                            <span className="text-white font-semibold">Wkrótce</span>
                        </div>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4">
                        <a href="https://github.com/cageeeg/cageeeg"
                           className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-orange-400 to-orange-600 text-black font-semibold rounded-xl hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300 hover:scale-[1.02]">
                            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                            Zobacz na GitHub
                        </a>
                        <a href="#docs"
                           className="inline-flex items-center justify-center px-6 py-3 border-2 border-orange-500/50 text-white font-semibold rounded-xl hover:border-orange-500 hover:text-orange-500 transition-all duration-300">
                            Zobacz dokumentację
                        </a>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-6">
                    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                        <h4 className="text-xl font-bold text-orange-500 mb-2">cageeeg-core</h4>
                        <p className="text-gray-400 text-sm mb-4">Główna biblioteka do przetwarzania sygnałów EEG</p>

                        <div className="flex items-center gap-2 text-sm text-gray-500">
                        <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                        <span>C#</span>
                    </div>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                        <h4 className="text-xl font-bold text-orange-500 mb-2">cageeeg-docs</h4>
                        <p className="text-gray-400 text-sm mb-4">Dokumentacja</p>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
                            <span>React</span>
                        </div>

                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <span className="w-3 h-3 bg-gray-600 rounded-full"></span>
                            <span>Markdown</span>
                        </div>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                        <h4 className="text-xl font-bold text-orange-500 mb-2">cageeeg-api</h4>
                        <p className="text-gray-400 text-sm mb-4">Sterowniki do urządzeń CageEEG</p>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                            <span>C#</span>
                        </div>
                    </div>
                    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                        <h4 className="text-xl font-bold text-orange-500 mb-2">cageeeg-sdk-python</h4>
                        <p className="text-gray-400 text-sm mb-4">Biblioteki do użytku we własnych aplikacjach</p>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <span className="w-3 h-3 bg-yellow-500 rounded-full"></span>
                            <span>Python</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                            <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                            <span>C#</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>)

export default OpenSourceComponent
